// extracted by mini-css-extract-plugin
module.exports = {"SubCatButton":"SearchTagButton_SubCatButton__23XQJ","SubCatSelected":"SearchTagButton_SubCatSelected__kKdv5","ButtonText":"SearchTagButton_ButtonText__1MHce"};